import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetPreAnalyticData = (surveyId) => {
  const query = useApiQuery(
    ['pre-analytic-data', surveyId],
    'sociogram',
    `/survey-pre-analityc-formats?surveyId=${surveyId}`,
    { enabled: !!surveyId } // sólo ejecuta si hay surveyId}
  )

  return {
    isLoadingPreAnalyticData: query.isLoading,
    isFetchingPreAnalyticData: query.isFetching,
    preAnalyticData: query.data ?? null,
    errorPreAnalyticData: query.isError ? query.error : null,
    reloadPreAnalyticData: query.refetch
  }
}
